import { render, staticRenderFns } from "./clipboard.vue?vue&type=template&id=1b5f2447&scoped=true&"
import script from "./clipboard.vue?vue&type=script&lang=ts&"
export * from "./clipboard.vue?vue&type=script&lang=ts&"
import style0 from "./clipboard.vue?vue&type=style&index=0&id=1b5f2447&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5f2447",
  null
  
)

export default component.exports